// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__s-Auh","upload":"Small_upload__AAMZT","imageWrap":"Small_imageWrap__3vTsM","removeBtn":"Small_removeBtn__2KUDn"};